// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"155":"7c6b589d","619":"11b745f6","661":"0b387266","812":"292ccf1d"}[chunkId] + ".chunk.css";
};